/** Plain-language names for the document types the server uses. */
const LABELS: Record<string, string> = {
  passport: "Passport photograph",
  government_id: "Government ID or NIN slip",
  indigene_attestation: "Indigene certificate or attestation letter",
  business_evidence: "Photo of your business",
  business_plan: "What you will spend the money on",
  farmland_evidence: "Evidence of your farmland",
};

export function docLabel(docType: string) {
  return LABELS[docType] ?? docType.replace(/_/g, " ");
}

/** Extra guidance shown under the upload control, where it helps. */
const HINTS: Record<string, string> = {
  passport: "A clear photo of your face, taken against a plain wall.",
  government_id:
    "Your NIN slip, voter's card, or driver's licence. Make sure the numbers are readable.",
  indigene_attestation:
    "An indigene certificate, or a letter from your ward head, district head, or an LGA officer. The letter must carry the signatory's phone number so we can confirm it.",
  business_evidence: "A photo of your shop, stall, or the goods you sell.",
  business_plan: "A short note or photo listing what you would buy.",
  farmland_evidence: "A photo of the land, or a document showing you farm it.",
};

export function docHint(docType: string) {
  return HINTS[docType] ?? null;
}
